import { render, staticRenderFns } from "./FiltresForCouponHistory.vue?vue&type=template&id=aca51820&scoped=true&"
import script from "./FiltresForCouponHistory.vue?vue&type=script&lang=js&"
export * from "./FiltresForCouponHistory.vue?vue&type=script&lang=js&"
import style0 from "./FiltresForCouponHistory.vue?vue&type=style&index=0&id=aca51820&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aca51820",
  null
  
)

export default component.exports